// import all reducers and group under combineReducers
import { combineReducers } from 'redux';

import authReducer from './authReducer';
import productReducer from './productReducer';
import resetPasswordReducer from './resetPasswordReducer';
import postalCodeReducer from './postalCodeReducer';
import paymentReducer from './paymentReducer';
import filterReducer from './filterReducer';
import dashboardReducer from './dashboardReducer'
import otpReducer from './one_time_passwordReducer'
import sellingReducer from './sellingReducer';
import sliderReducer from './sliderReducer';
import topUpReducer from './topUpReducer';
import disbursementReducer from './disbursementReducer';
import raffleReducer from './raffleReducer';
import loginReferralReducer from './loginReferralReducer';
import commonGroundReducer from './commonGroundReducer';
import sortFilterSellerReducer from './sortFilterSellerReducer';
import offerReducer from './offerReducer';
import categoryReducer from './categoryReducer';
import menuReducer from './menuReducer';
import skuRequestReducer from './skuRequestReducer';
import kickPointReducer from './kickPointReducer';
import kafairReducer from './kafairReducer';
import uiReducer from './uiReducer';
import surveyReducer from './surveyReducer';
import globalReducerHandler from './globalReducer';
import brandsProductReducer from "./brandProductReducer"
import { loadingBarReducer } from 'react-redux-loading-bar';

const rootReducer = combineReducers({
  dataProduct: productReducer,
  dataAuth: authReducer,
  dataResetPassword: resetPasswordReducer,
  dataPostalCode: postalCodeReducer,
  dataPayment: paymentReducer,
  dataHistory: dashboardReducer,
  loadingBar: loadingBarReducer,
  filterReducer: filterReducer,
  dataOtp: otpReducer,
  dataSelling: sellingReducer,
  sliderHome: sliderReducer,
  dataTopUp: topUpReducer,
  dataDisbursement: disbursementReducer,
  raffleReducer: raffleReducer,
  dataCommonGround: commonGroundReducer,
  dataSortFilter: sortFilterSellerReducer,
  dataOffer: offerReducer,
  dataCategory: categoryReducer,
  dataMenu: menuReducer,
  dataSkuRequest: skuRequestReducer,
  loginReferralReducer,
  dataKickPoint: kickPointReducer,
  dataKaFair: kafairReducer,
  dataUi: uiReducer,
  dataSurvey: surveyReducer,
  globalValue: globalReducerHandler,
  dataProductBrandPage: brandsProductReducer
});

export default rootReducer;
